import React, { useEffect } from 'react';
import * as style from 'theme/components/dialog/dialog.module.scss'

import classesBuilder from 'shared/utils/classesBuilder'

import BackDrop from 'shared/components/backdrop'
import Button from 'shared/components/button'

import DialogType from './types/dialog.type'

import UseDialog from './hooks/useDialog'

const Dialog: React.FC<DialogType> = ({
  autoOpen,
  body,
  children,
  close,
  elevation,
  footer,
  head,
  instanceEmitter,
  persistent,
  outlined,
  rounded,
  shadow,
  size = 'small',
  title,
  onClose = () => {},
  open,
  onOpen
}) => {
  const { useOpenDialog, usePersistent, useShowDialog, onOpenDialog, onCloseDialog } = UseDialog({
    isAutoOpen: autoOpen,
    onClose,
    onOpen,
  })

  const classNamesDialog = {
    dialog: true,
    [`elevation${elevation}`]: elevation,
    persistent: usePersistent,
    outlined,
    rounded,
    shadow,
    show: useShowDialog,
    [size]: size,
  }

  if (instanceEmitter) {
    Object.assign(instanceEmitter, {
      open: onOpenDialog,
      dismiss: onCloseDialog,
    })
  }

  useEffect(() => {
    if (open === undefined) {
      return
    }

    open ? onOpenDialog() : onCloseDialog()
  }, [onCloseDialog, onOpenDialog, open]);

  return useOpenDialog ? (
    <>
      <BackDrop blur show={useShowDialog} onClose={() => onCloseDialog(!!persistent)} />
      <div
        style={typeof size === 'number' ? { width: size } : undefined}
        className={classesBuilder(style, classNamesDialog)}
      >
        {close && !persistent ? (
          <div className={classesBuilder(style, { close: true })}>
            <Button icon="close-outline" onClick={() => onCloseDialog()} />
          </div>
        ) : null}
        <div className={classesBuilder(style, { head: true })}>{head}</div>
        <div className={classesBuilder(style, { head: true })}>{title}</div>
        <div className={classesBuilder(style, { body: true })}>
          <div className={classesBuilder(style, { context: true })}>{body || children}</div>
        </div>
        <div className={classesBuilder(style, { footer: true })}>{footer}</div>
      </div>
    </>
  ) : null
}

export default Dialog
